<template>
    <div class="container-btn-modify">
        <a 
            :href="extras.extraLink"
            target="_blank"
            :style="getStylesModify"
            class="btn-booking-cms-modify" >
                {{ extras.extraLabel }}
        </a>
    </div>
</template>

<script>

    export default{
        // 1-5
        name: 'BookingButtonModify',
        props:{
           extras: Object,
           styles: Object,
           template: String
        },
        computed:{
            getStylesModify(){
                const { padding , textTransform  , ...rest } = this.styles
                let margin = '0'
                if(this.template === 'fixed'){
                    margin = '0 0 0 25px'
                }else{
                    margin = '10px 5px'
                }
                return{
                    ...rest,
                    '--color-modify': this.styles.color,
                    margin: margin
                }
            }
        },
    }

</script>

<style lang="scss">
    .container-btn-modify{
        align-self: center;
    }
    .btn-booking-cms-modify{
        cursor: pointer;
        position: relative;
        padding-bottom: 5px;
        display: inline-block;
        a{
            text-transform: capitalize;
        }
        &:before{
            content: '';
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 1px;
            background-color: var(--color-modify);
        }
        &:hover{
            opacity: 0.7;
            &:before{
                opacity: 0.7;
            }
        }
    }
</style>